import { buttonVariants } from '@/components/ui/button';
import { buildGoogleMapsSearchUrl, type AddressInput } from '@/lib/google-maps-url';
import { cn } from '@/lib/utils';
import { MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

export interface GoogleMapsLinkProps {
    address: AddressInput;
    className?: string;
}

export const GoogleMapsLink = ({ address, className }: GoogleMapsLinkProps) => {
    const mapsUrl = buildGoogleMapsSearchUrl(address);
    if (!mapsUrl) return null;

    return (
        <Link
            to={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
                buttonVariants({
                    variant: 'link',
                }),
                'p-0 h-lh',
                className,
            )}
        >
            <MapPinIcon className="h-4 w-4" />
        </Link>
    );
};
